import React, { useEffect, useState } from "react";

import { Dispatch } from "redux";
import { connect } from "react-redux";
import { SelectorNames } from "@goaigua/go-components";

import {
    setDateFormat,
    setTimeFormat,
    setWeekStartDay,
} from "redux/reducers/preferences/actions";

import { OptionsType } from "types/generic/index";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/pro-light-svg-icons";
import { useIntl } from "react-intl";

type TimedateFormatType = {
    dateFormat: string;
    timeFormat: string;
    weekStartDay: string;
    updateDateFormat: (dateFormat: string) => void;
    updateTimeFormat: (timeFormat: string) => void;
    updateWeekStartDay: (weekStartDay: string) => void;
    timeDateFormat: {
        dateFormat: string;
        timeFormat: string;
        weekStartDay: string;
    };
    setTimeDateFormat: React.Dispatch<
        React.SetStateAction<{
            dateFormat: string;
            timeFormat: string;
            weekStartDay: string;
        }>
    >;
    setIsBtnActive: React.Dispatch<React.SetStateAction<boolean>>;
    exampleModalPreferences: string[];
};

const TimeFormatContent = ({
    timeDateFormat,
    setTimeDateFormat,
    setIsBtnActive,
    exampleModalPreferences,
}: TimedateFormatType) => {
    const intl = useIntl();
    const [optionDateDropdown, setOptionDateDropdown] = useState<OptionsType[]>(
        [
            {
                id: 0,
                description: "dd/MM/yyyy",
                selected: false,
                value: "DD/MM/YYYY",
            },
            {
                id: 1,
                description: "MM/dd/yyyy",
                selected: false,
                value: "MM/DD/YYYY",
            },
            {
                id: 2,
                description: "yyyy/MM/dd",
                selected: false,
                value: "YYYY/MM/DD",
            },
            {
                id: 3,
                description: "dd-MM-yyyy",
                selected: false,
                value: "DD-MM-YYYY",
            },
            {
                id: 4,
                description: "MM-dd-yyyy",
                selected: false,
                value: "MM-DD-YYYY",
            },
            {
                id: 5,
                description: "yyyy-MM-dd",
                selected: false,
                value: "YYYY-MM-DD",
            },
            {
                id: 6,
                description: "dd.MM.yyyy",
                selected: false,
                value: "DD.MM.YYYY",
            },
            {
                id: 7,
                description: "MM.dd.yyyy",
                selected: false,
                value: "MM.DD.YYYY",
            },
            {
                id: 8,
                description: "yyyy.MM.dd",
                selected: false,
                value: "YYYY.MM.DD",
            },
            {
                id: 9,
                description: "dd.MM.yy",
                selected: false,
                value: "DD.MM.YY",
            },
            {
                id: 10,
                description: "MM.dd.yy",
                selected: false,
                value: "MM.DD.YY",
            },
            {
                id: 11,
                description: "yy.MM.dd",
                selected: false,
                value: "YY.MM.DD",
            },
        ]
    );
    const [optionTimeDropdown, setOptionTimeDropdown] = useState<OptionsType[]>(
        [
            {
                id: 0,
                description: "HH:MM (24h)",
                selected: false,
                value: "HH:mm",
            },
            {
                id: 1,
                description: "HH:MM (12h)",
                selected: false,
                value: "h:mm A",
            },
        ]
    );
    const [optionWeekStartDayDropdown, setOptionWeekStartDayDropdown] =
        useState<OptionsType[]>([
            {
                id: 0,
                description: intl.formatMessage({
                    id: "app.components.preferences.monday",
                }),
                selected: false,
                value: "0",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.tuesday",
                }),
                selected: false,
                value: "1",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.wednesday",
                }),
                selected: false,
                value: "2",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.thursday",
                }),
                selected: false,
                value: "3",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.friday",
                }),
                selected: false,
                value: "4",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.saturday",
                }),
                selected: false,
                value: "5",
            },
            {
                id: 1,
                description: intl.formatMessage({
                    id: "app.components.preferences.sunday",
                }),
                selected: false,
                value: "6",
            },
        ]);

    useEffect(() => {
        changeDateValue();
    }, [timeDateFormat.dateFormat]);

    useEffect(() => {
        changeTimeValue();
    }, [timeDateFormat.timeFormat]);

    useEffect(() => {
        changeWeekDayValue();
    }, [timeDateFormat.weekStartDay]);

    const changeDateValue = () => {
        const optionDateDropdownAux = optionDateDropdown.slice();

        const optionTrueToFalseIndex = optionDateDropdownAux.findIndex(
            (option) => option.selected === true
        );

        optionDateDropdownAux[optionTrueToFalseIndex] = {
            ...optionDateDropdownAux[optionTrueToFalseIndex],
            selected: false,
        };

        const optionFalseToTrueIndex = optionDateDropdownAux.findIndex(
            (option) => option.value === timeDateFormat.dateFormat
        );

        optionDateDropdownAux[optionFalseToTrueIndex] = {
            ...optionDateDropdownAux[optionFalseToTrueIndex],
            selected: true,
        };

        setOptionDateDropdown(optionDateDropdownAux);
    };

    const changeTimeValue = () => {
        const optionTimeDropdownAux = optionTimeDropdown.slice();

        const optionTrueToFalseIndex = optionTimeDropdownAux.findIndex(
            (option) => option.selected === true
        );

        optionTimeDropdownAux[optionTrueToFalseIndex] = {
            ...optionTimeDropdownAux[optionTrueToFalseIndex],
            selected: false,
        };

        const optionFalseToTrueIndex = optionTimeDropdownAux.findIndex(
            (option) => option.value === timeDateFormat.timeFormat
        );

        optionTimeDropdownAux[optionFalseToTrueIndex] = {
            ...optionTimeDropdownAux[optionFalseToTrueIndex],
            selected: true,
        };

        setOptionTimeDropdown(optionTimeDropdownAux);
    };

    const changeWeekDayValue = () => {
        const optionWeekStartDayDropdownAux =
            optionWeekStartDayDropdown.slice();

        const optionTrueToFalseIndex = optionWeekStartDayDropdownAux.findIndex(
            (option) => option.selected === true
        );

        optionWeekStartDayDropdownAux[optionTrueToFalseIndex] = {
            ...optionWeekStartDayDropdownAux[optionTrueToFalseIndex],
            selected: false,
        };

        const optionFalseToTrueIndex = optionWeekStartDayDropdownAux.findIndex(
            (option) => option.value === timeDateFormat.weekStartDay
        );

        optionWeekStartDayDropdownAux[optionFalseToTrueIndex] = {
            ...optionWeekStartDayDropdownAux[optionFalseToTrueIndex],
            selected: true,
        };

        setOptionWeekStartDayDropdown(optionWeekStartDayDropdownAux);
    };

    return (
        <>
            <div className="c-body">
                <FontAwesomeIcon icon={faCalendarAlt} />
                <span className="c-body__title c-body__title--text">
                    {intl.formatMessage({
                        id: "app.components.preferences.timeFormat",
                    })}
                </span>
                <span className="o-divider-line"></span>
            </div>
            <div className="c-body__container">
                <div className="c-body__dropdown">
                    <SelectorNames
                        items={optionDateDropdown}
                        search={false}
                        locale={""}
                        label={intl.formatMessage({
                            id: "app.components.preferences.date",
                        })}
                        onChangeItems={function (items: any): void {
                            setTimeDateFormat({
                                ...timeDateFormat,
                                dateFormat: items.value,
                            });
                            setIsBtnActive(true);
                        }}
                        size="s"
                    />
                </div>

                <div className="c-body__dropdown">
                    <SelectorNames
                        items={optionTimeDropdown}
                        search={false}
                        locale={""}
                        label={intl.formatMessage({
                            id: "app.components.preferences.hour",
                        })}
                        onChangeItems={function (items: any): void {
                            setTimeDateFormat({
                                ...timeDateFormat,
                                timeFormat: items.value,
                            });
                            setIsBtnActive(true);
                        }}
                        size="s"
                    />
                </div>
                <div className="c-body__dropdown">
                    <SelectorNames
                        items={optionWeekStartDayDropdown}
                        search={false}
                        locale={""}
                        label={intl.formatMessage({
                            id: "app.components.preferences.firstDayOfTheWeek",
                        })}
                        onChangeItems={function (items: any): void {
                            setTimeDateFormat({
                                ...timeDateFormat,
                                weekStartDay: items.value,
                            });
                            setIsBtnActive(true);
                        }}
                        size="m"
                    />
                </div>
            </div>
            <div className="c-body__example-text">
                <span className="c-body__example-text c-body__example-text--example">
                    {intl.formatMessage({
                        id: "app.components.preferences.example",
                    })}
                    :{" "}
                </span>
                <p>{exampleModalPreferences[0]}</p>
                <p>{exampleModalPreferences[1]}</p>
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        dateFormat: state.preferences.timeDateFormat.dateFormat,
        timeFormat: state.preferences.timeDateFormat.timeFormat,
        weekStartDay: state.preferences.timeDateFormat.weekStartDay,
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        updateDateFormat: (dateFormat: string) =>
            dispatch(setDateFormat(dateFormat)),
        updateTimeFormat: (timeFormat: string) =>
            dispatch(setTimeFormat(timeFormat)),
        updateWeekStartDay: (weekStartDay: string) =>
            dispatch(setWeekStartDay(weekStartDay)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeFormatContent);
